var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-group',[_vm._l((_vm.mapImages),function(config){return _c('v-image',{key:config.name,ref:"images",refInFor:true,attrs:{"config":config},on:{"dragend":_vm.handleDragend,"click":_vm.handleStageMouseDown,"transformend":_vm.handleTransformEnd}})}),_c('v-transformer',{ref:"transformer",attrs:{"config":{
            anchorStroke: '#21A0A0',
            anchorFill: '#cfffff',
            anchorSize: 12,
            borderStroke: '#21A0A0',
            borderStrokeWidth: 2,
            borderDash: [6, 8],
            anchorCornerRadius: 6,
            anchorStrokeWidth: 1.6,
        }}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }